import { useRecipeGrid } from '@/components/RecipeGrid/RecipeGridProvider';
import { memo } from 'react';
import { Card } from '@/components/Cards';
import type { ISuggestedData } from '@/components/Cards/types';
import { TrackingService } from '@/service/tracking/trackingService';

type Props = {
  difficultyCopy?: Record<string, string>;
  categoryName?: string;
  host: string;
  userToken: string;
};

export const RecipeGrid = memo(({ difficultyCopy, host, categoryName, userToken }: Props) => {
  const { state } = useRecipeGrid();

  const trackCardClick = (recipe: ISuggestedData) => {
    const appliedFilterCategory =
      state.facetFilters?.map((item) => item[0].split(':')[0]).join(',') || 'na';
    const appliedFiltersCategory =
      state.facetFilters
        ?.flatMap((item) => item.map((appliedCategory) => appliedCategory.split(':')[1]))
        .join(',') || 'na';

    const difficulty = recipe?.information?.difficulty;
    const difficultyText = difficultyCopy && difficulty ? difficultyCopy[difficulty] : 'na';

    TrackingService.seeRecipeClick(
      categoryName || 'na',
      recipe?.category || 'na',
      recipe?.title || 'na',
      recipe?.id || 0,
      difficultyText,
      recipe?.information?.rating || 'na',
      recipe?.information?.preparationTime || recipe?.information?.totalTime || 'na',
      appliedFilterCategory,
      appliedFiltersCategory,
      state.sortMethod || 'na',
    );

    TrackingService.recipeCategoryPageConversionAfterFiltering(
      (window.dataLayer as Record<string, string>[]) || [],
      recipe?.objectID || '',
      recipe?.queryID || '',
      userToken,
    );
  };

  return (
    <>
      <div itemScope itemType="https://schema.org/ItemList" style={{ display: 'none' }}>
        {state.recipes?.map((recipe, index) => (
          <div
            key={recipe.id}
            itemProp="itemListElement"
            itemScope
            itemType="https://schema.org/ListItem"
          >
            <span itemProp="position">{index + 1}</span>
            <span itemProp="url">{`https://${host}${recipe.link?.url}`}</span>
          </div>
        ))}
      </div>
      <div className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-4 auto-rows-min min-h-[480px]">
          {state.recipes.map((recipe) => {
            return (
              <Card
                key={recipe.id}
                data={recipe}
                cardType="medium"
                link={recipe.link}
                showInfo
                height="480px"
                copyDictionary={difficultyCopy}
                trackingEvent={() => trackCardClick(recipe)}
              />
            );
          })}
        </div>
      </div>
    </>
  );
});

RecipeGrid.displayName = 'RecipeGrid';
